<template>
  <div class="u-item clearfix">
    <div class="u-avatar">
      <router-link
        :to="{ path: '/home', query: { userId: commentOBj.commentAuthor } }"
        class="avatar-f"
      >
        <img :src="commentOBj.imgUrl" alt="" />
      </router-link>
    </div>
    <div class="u-infoes">
      <div class="u-name-title clearfix">
        <router-link
          :to="{ path: '/home', query: { userId: commentOBj.commentAuthor } }"
          class="name"
          >{{ commentOBj.commentAuthorName }}</router-link
        >
        <div
          class="new-tchh clearfix"
          v-if="
            commentOBj.commentAuthorRankName != '' &&
              commentOBj.commentAuthorRankName != 'null'
          "
        >
          <i
            class="icon zs"
            v-if="commentOBj.commentAuthorRankName.split(',')[1] == '资深作者'"
          ></i>
          <i
            class="icon yx"
            v-if="commentOBj.commentAuthorRankName.split(',')[1] == '优秀作者'"
          ></i>
          <i
            class="icon hy"
            v-if="commentOBj.commentAuthorRankName.split(',')[1] == '活跃作者'"
          ></i>
          <span class="zuoz">{{
            commentOBj.commentAuthorRankName.split(",")[1]
          }}</span>
          <span class="shu">|</span>
          <span class="liny">{{
            commentOBj.commentAuthorRankName.split(",")[0]
          }}</span>
        </div>
      </div>
      <div class="words">
        回复<router-link
          :to="{ path: '/home', query: { userId: commentOBj.replierId } }"
          class="uu-name"
          >{{ commentOBj.replierName }}</router-link
        >：{{ commentOBj.commentContent }}
      </div>
      <div class="zan-cai-date clearfix" v-if="isLogin">
        <div class="zan-cai">
          <!--<div class="item active">-->
          <!--<span class="zc-icon zan"></span>-->
          <!--<span class="count">200</span>-->
          <!--</div>-->
          <!--<div class="item">-->
          <!--<span class="zc-icon cai"></span>-->
          <!--<span class="count">200</span>-->
          <!--</div>-->
          <div
            class="item"
            @click="pinglunThirdEvent(commentOBj)"
            v-if="!isProView"
          >
            <span class="zc-icon pinglun"></span>
          </div>
          <div class="item" v-if="loginUserId == commentOBj.commentAuthor">
            <span class="zc-icon shanchu" @click="del(commentOBj)"></span>
          </div>
        </div>
        <div class="date">{{ commentOBj.commentTs | formatTime }}</div>
      </div>
      <div class="console-ipt" v-if="showFours">
        <el-form :model="formChild" ref="formChild">
          <el-input
            class="textarea"
            type="textarea"
            :rows="1"
            placeholder="请输入内容"
            v-model="formChild.commentContent"
          >
          </el-input>
          <div class="checked-btn clearfix">
            <!--          <el-checkbox class="checked" v-model="formChild.activitiesAnd">同时转发到我的动态</el-checkbox>-->
            <el-button
              class="fabu-btn"
              type="primary"
              size="mini"
              @click="submitChild"
              v-if="isLogin"
              >发布</el-button
            >
            <el-button
              class="fabu-btn"
              type="primary"
              size="mini"
              @click="toLog"
              v-else
              >请登录</el-button
            >
          </div>
        </el-form>
      </div>
    </div>
  </div>
</template>

<script type="text/ecmascript-6">
  import commentApi from '@/api/comment'
export default {
  props: {
    obj:{
      type:Object,
    },
    isProView:{
      type:Boolean
    }
    ,
    loadShow:{
      type:Boolean
    }
  },
  components: {

  },
  data () {
    return {
      isLogin:false,
      loginUserId:0,
      commentOBj:this.obj,
      showFours: false,
      textConFours: '',
      formChild:{
        commentObjectId:this.obj.commentObjectId,
        commentObjectType:this.obj.commentObjectType,
        commentParent:-1,//0为父级评论
        commentContent:'',
        commentAuthor:0,

        commentParentAuthorName:'',
        commentParentAuthor:0,
        commentParentRankId:'',
        commentParentRankName:'',

        repliedCommentId:0,
        replierId:0,
        replierName :'',

        activitiesAnd:false,
      }
    }
  },
  mounted(){
    let this_ = this
    if(this.global.isLogin){
      this_.loginUserId = this.global.userModel.id
      this_.isLogin = true
    }
  },
  methods: {
    pinglunThirdEvent (item) {
      this.showFours = !this.showFours

      if(item){
        this.formChild.repliedCommentId = item.id
        this.formChild.replierId = item.commentAuthor
        this.formChild.replierName = item.commentAuthorName

        this.formChild.commentParent = item.commentParent
        this.formChild.commentParentAuthorName = item.commentParentAuthorName
        this.formChild.commentParentAuthor = item.commentParentAuthor
        if(item.commentAuthorRankId){
          this.formChild.commentParentRankId = item.commentParentRankId
          this.formChild.commentParentRankName = item.commentParentRankName
        }
      }
    },


    //发布子留言
    submitChild( ){
      let this_ = this
      console.log("fourth==============");
      if(this_.formChild.commentContent.trim() == ''){
        this_.$notify({
          title: "留言不能为空",
          type: 'error',
          showClose: false,
          duration: 2000
        })
        return false;
      }

      this_.formChild.commentAuthor = this_.loginUserId
      commentApi.update(this_.formChild).then(re =>{
        if(re.code==1){
          this_.formChild.commentContent=''
          this_.setAddCommentNum()
          this_.$parent.setEmpty();
          this_.$notify({
            title: re.message,
            type: 'success',
            showClose: false,
            duration: 2000
          })
        }else{
          this_.$notify({
            title: re.message,
            type: 'error',
            showClose: false,
            duration: 2000
          })
        }

        //this_.pinglunThirdEvent()
      })
    },
    del(item){
      let this_ = this
      this.$confirm('确认删除吗？')
              .then(() => {
                // console.log(_)
                commentApi.delete(item.id).then(re => {
                  if (re.code === 1) {
                    this_.$parent.setEmpty();
                    this_.setDelCommentNum(re.response)
                    this_.$notify({
                      title: re.message,
                      type: 'success',
                      showClose: false,
                      duration: 2000
                    })
                  } else {
                    this_.$notify({
                      title: re.message,
                      type: 'error',
                      showClose: false,
                      duration: 2000
                    })
                  }
                })
              })
              .catch(() => {
                // console.log('取消')
              })
    },
    toLog(){
      this.$router.push({
        path:'/login?callback=' + window.location.href,
      })

    },
    setAddCommentNum(){
      this.$parent.setAddCommentNum()
    },
    setDelCommentNum(cutNum){
      this.$parent.setDelCommentNum(cutNum)
    }
  }
}
</script>

<style scoped lang="less"></style>
